module.exports = __webpack_public_path__ + "static/media/colgate_logo.78a47838.png";